/**
 * O toque da chamada de voz no chat do cliente e do técnico.
 *
 * Existe desde 21/10. Antes só o painel tocava: o técnico em campo recebia a chamada em
 * silêncio, com o celular no bolso, e só via se já estivesse olhando a tela — que é
 * justamente o que ele não está fazendo enquanto instala.
 *
 * Em laço, porque uma ligação insiste até alguém atender ou desistir. E sem preferência
 * para desligar: aqui não há chiado de mensagem para silenciar, só o telefone.
 */
const ARQUIVO_TOQUE = '/ligacao.mp3';

let toque: HTMLAudioElement | null = null;

export function tocarToque(): void {
  try {
    toque ??= new Audio(ARQUIVO_TOQUE);
    toque.loop = true;
    toque.currentTime = 0;
    // A promessa é ignorada de propósito: se o navegador recusar (autoplay antes de
    // qualquer toque na tela), não há o que fazer nem o que avisar — a chamada continua
    // aparecendo na tela.
    void toque.play().catch(() => undefined);
  } catch {
    /* sem áudio: a chamada ainda aparece na tela, só não soa */
  }
}

export function pararToque(): void {
  try {
    toque?.pause();
    if (toque) toque.currentTime = 0;
  } catch {
    /* nada a fazer */
  }
}
